import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { isQcLiteE2eBypass } from '../utils/qcLiteE2eBypass';

/** Default route when the user is not signed in (must match post-logout navigation). */
export const SIGN_IN_PATH = '/signin';

export default function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  if (isQcLiteE2eBypass()) {
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
        <p className="text-sm text-gray-600 dark:text-gray-400">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={SIGN_IN_PATH} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
